import useStore from "stores/index";

export const sendChatNotificaton = (threadKey, classroomId, username, msg, showClassroomName = false, displayName) => {
	const userLabel = displayName || username;
	const senderLabel = showClassroomName ? classroomId : userLabel;

	const onClick = () => {
		useStore.getState().chat.setSelectedClassId(classroomId);

		if (!useStore.getState().chat.chatWindowOpen) {
			useStore.getState().chat.toggleChatWindow(true);
		}

		useStore.getState().chat.setSelectedStudentName(username);
		useStore.getState().chat.setSelectedThreadKey(threadKey);
	};

	sendNotification(`New message from ${senderLabel}`, msg, onClick);
};

export function sendNotification(title, body, onClick = () => {}, requireInteraction = false) {
	const notification = new Notification(title, {
		body,
		requireInteraction,
	});

	notification.onclick = () => {
		notification.close();
		onClick();
	};
}
